import { makeVar } from '@apollo/client';
import { emptyArray } from 'utils/constants';

export const defaultNonWorkingDays = {
  nonWorkingDayId: null,
  nonWorkingDayDate: null,
  description: null,
  workingSiteId: null,
  workingDay: false,
  validInAllContexts: false,
  contexts: emptyArray
};

export const nonWorkingDaysModalVar = makeVar({ open: false, item: defaultNonWorkingDays });
